import { Button, Input } from "@delibrandev/utils";
import { OptionsList } from "./OptionsList";

export const GroupDetail = ({
  styles,
  groupActive,
  groupNameDraft,
  setGroupNameDraft,
  optionDrafts,
  setOptionDrafts,
  onSaveGroupName,
  onNewOption,
  onSaveOptionName,
  onAddGroupToProduct,
  isMainGroupDraft,
  setIsMainGroupDraft,
}) => {
  return (
    <section className={styles.detail}>
      <div className={styles.detailHeader}>
        <div>
          <h6 className={styles.title}>Gestión del grupo</h6>
          <div className={styles.subtitle}>{groupActive ? "" : "Selecciona un grupo"}</div>
        </div>

        <div className={styles.detailHeaderActions}>
          <Button text="Agregar grupo al producto" icon={null} customClass="customButtonColor2" action={onAddGroupToProduct} />
        </div>
      </div>

      {!groupActive ? (
        <div className={styles.empty}>Selecciona un grupo para editarlo.</div>
      ) : (
        <>
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.cardTitle}>Nombre del grupo</div>
              <Button text="Guardar" icon={null} customClass="customButtonColor2" action={onSaveGroupName} />
            </div>

            <Input
              id={groupActive.optionGroupId}
              type="text"
              placeholder=""
              classname="w-100"
              icon={null}
              iconType={null}
              iconPositionRight
              label=""
              description=""
              defaultValue={groupNameDraft}
              onChange={(value) => setGroupNameDraft(value)}
            />
            <label className={styles.checkboxRow}>
              <input
                className="custom-checkbox"
                type="checkbox"
                checked={!!isMainGroupDraft}
                onChange={(e) => setIsMainGroupDraft(e.target.checked)}
              />
              <span>Grupo principal</span>
            </label>
          </div>

          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.cardTitle}>Opciones</div>
              <Button text="Nueva opción" icon={null} customClass="customButtonColor1" action={onNewOption} />
            </div>

            <OptionsList
              styles={styles}
              groupActive={groupActive}
              optionDrafts={optionDrafts}
              setOptionDrafts={setOptionDrafts}
              onSaveOptionName={onSaveOptionName}
            />
          </div>
        </>
      )}
    </section>
  );
};
